// extracted by mini-css-extract-plugin
export var columnItem = "_de-3";
export var columnItemDraggable = "_de-4";
export var dragHandle = "_de-0";
export var dragHandleHovered = "_de-1";
export var dropdown = "_de-5";
export var dropdownContent = "_de-7";
export var dropdownInner = "_de-6";
export var filterDropdownHeader = "_de-8";
export var icon = "_de-2";
export var sectionDivider = "_de-9";